<template>
  <div id="new" class="sav-wrapper">
    <Topbar/>
    <div class="sav-container">
      <Header title="Νέα ασφάλεια"/>
      <div id="sav-new" class="sav-container sav-add-categories">
        <router-link tag="li" to="/car/add">
          <img :src="require('./../assets/icons/car.png')" alt="Ασφάλεια Αυτοκινήτου">
        </router-link>
        <router-link tag="li" to="/moto/add">
          <img :src="require('./../assets/icons/moto.png')" alt="Ασφάλεια Μηχανής">
        </router-link>
        <router-link tag="li" to="/house/add">
          <img :src="require('./../assets/icons/house.png')" alt="Ασφάλεια Κατοικίας">
        </router-link>
        <router-link tag="li" to="/health/add">
          <img :src="require('./../assets/icons/health.png')" alt="Ασφάλεια Υγείας">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from './Topbar.vue'
import Header from './Header.vue'

export default {
  props: [],
  components: {
    Topbar,
    Header
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

#sav-new {
  padding-top: 20px;
}

.sav-add-categories {
  display: flex;
  flex-wrap: wrap;
  padding-left: 100px;
  padding-right: 100px;

  li {
    cursor: pointer;
    display: inline-block;
    flex: 1 0 49.2%; /* explanation below */
    display: flex;
    justify-content: center;
    align-items: center;
    height: 220px;
    background-color: darken($red, 10%);;
    margin-bottom: 10px;
    border-radius: 20px;
    transition: all .3s ease-out;

    &:not(:nth-child(2n)) {
      margin-right: 10px;
    }

    &:hover {
      background-color: darken($red, 20%);
    }
  }
}
</style>
